import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { TableRow, TableCell, IconButton } from "@mui/material";
import moment from "moment";
import CrudActions from "../../../../partials/datatable/CrudActions";
import Datatable from "../../../../partials/datatable/Datatable";
import { QuizApiServiceImpl } from "../../../../services/Ananse/impl/QuizApiService";
import { titlePage } from "utils/titlepage";
import { useTranslation } from "_metronic/i18n/language";
import { Link } from "react-router-dom";
import { FaClone } from "react-icons/fa";
import { labelQuizType } from "./utils/labelTypeQuiz";

const QuizList: React.FC = () => {
  const translate = useTranslation();
  const api = new QuizApiServiceImpl();
  const [quiz, setQuiz] = useState<any[]>([]);
  const [reload, setReload] = useState(false);
  const [isActive, setIsActive] = useState(true);

  const onConfirmChangeStatus = async (obj: any) => {
    if (!obj.deletedAt) {
      await api.delete(obj.quizId);
    } else {
      await api.activate(obj.quizId);
    }

    setReload(!reload);
  };

  useEffect(() => {
    titlePage(
      `${translate("screens.quiz.list.title")} - ${translate("labels_admin")}`,
    );
  }, []);

  const headRows = [
    { label: translate("screens.quiz.list.actions") },
    { column: "Name", label: translate("screens.quiz.list.name") },
    {
      column: "Campaign.Name",
      label: translate("screens.quiz.list.campaign"),
    },
    {
      column: "Language",
      label: translate("screens.quiz.labels.language"),
    },
    {
      column: "Questions",
      label: translate("screens.quiz.list.questions"),
    },
    {
      column: "Type",
      label: translate("screens_fragrance_labels_type"),
    },
    {
      column: "CreatedAt",
      label: translate("screens.quiz.list.created"),
    },
    {
      column: "UpdatedAt",
      label: translate("screens.quiz.list.updated"),
    },
  ];

  const formatRow = (r: any) => (
    <TableRow hover tabIndex={-1} key={r.quizId}>
      <TableCell>
        <CrudActions
          actions={["toggle", "edit"]}
          module="quiznew"
          onConfirmChangeStatus={onConfirmChangeStatus}
          id={r.quizId}
          obj={r}
        />
        {/* <Link to={`/admin/quiz/${r.quizId}/clone`}> */}
        <Link to={`/admin/quizclone/${r.quizId}`}>
          <IconButton size="small" title={translate("buttons.clone")}>
            <FaClone />
          </IconButton>
        </Link>
      </TableCell>
      <TableCell scope="row">{r.name}</TableCell>
      <TableCell scope="row">{r.campaign?.name}</TableCell>
      <TableCell scope="row">{r.language}</TableCell>
      <TableCell scope="row">{r.questions?.length}</TableCell>
      <TableCell scope="row">{labelQuizType(r.type, translate)}</TableCell>
      <TableCell scope="row">
        {moment(r.createdAt).format("DD/MM/YYYY HH:mm")}
      </TableCell>
      <TableCell scope="row">
        {moment(r.updatedAt).format("DD/MM/YYYY HH:mm")}
      </TableCell>
    </TableRow>
  );

  const filterTeste = quiz;

  return (
    <Datatable
      title={translate("screens.quiz.list.title")}
      endpoint="/quiz?Type=1"
      headRows={headRows}
      formatRow={formatRow}
      rows={filterTeste}
      setRows={setQuiz}
      reload={reload}
      placeholderSearch={translate("screens.quiz.placeholders.search")}
      isActive={isActive}
      buttons={[
        {
          label: translate("datatable.add"),
          onClick: null,
          icone: "add",
          path: "/admin/quiznew/create",
        },
      ]}
    />
  );
};

const mapStoreToProps = (store: any) => ({
  i18n: store.i18n,
});

export default connect(mapStoreToProps, null)(QuizList);
